"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var ValidationError = /** @class */ (function () {
    function ValidationError() {
    }
    Object.defineProperty(ValidationError.prototype, "identityId", {
        get: function () {
            return this._identityId;
        },
        set: function (value) {
            this._identityId = value;
        },
        enumerable: true,
        configurable: true
    });
    ValidationError.prototype.getMessage = function () {
        return this._message;
    };
    ValidationError.prototype.setMessage = function (message) {
        this._message = message;
    };
    ValidationError.prototype.getRelatedFields = function () {
        return this._relatedFields;
    };
    ValidationError.prototype.setRelatedFields = function (relatedFields) {
        this._relatedFields = relatedFields;
    };
    Object.defineProperty(ValidationError.prototype, "validatorLabel", {
        get: function () {
            return this._validatorLabel;
        },
        set: function (value) {
            this._validatorLabel = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ValidationError.prototype, "validationDisplay", {
        get: function () {
            return this._validationDisplay;
        },
        set: function (value) {
            this._validationDisplay = value;
        },
        enumerable: true,
        configurable: true
    });
    return ValidationError;
}());
exports.ValidationError = ValidationError;
//# sourceMappingURL=validation-error.model.js.map